<template>
  <el-drawer
    v-if="visible"
    :title="$l('drawer_title_edit_group_info') || '编辑分组信息'"
    :visible.sync="visible"
    direction="rtl"
    :size="853"
    show-close
    append-to-body
    :before-close="handleClose"
    :wrapperClosable="false"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        @reload="$emit('reload')"
        @close="close()"
        @updateCode="updateCode"
        :evgPackingSchemeCode="evgPackingSchemeCode"
        :evgPackingSchemeGroupCode="evgPackingSchemeGroupCode"
      />
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    evgPackingSchemeCode: { type: String, default: '' },
    evgPackingSchemeGroupCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    updateCode(code) {
      this.$emit('update:evgPackingSchemeGroupCode', code)
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('tips_confirm_checkSaved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.close()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}
</style>
